/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordVerifyAttestationData } from './PasswordVerifyAttestationData';
import {
    PasswordVerifyAttestationDataFromJSON,
    PasswordVerifyAttestationDataFromJSONTyped,
    PasswordVerifyAttestationDataToJSON,
} from './PasswordVerifyAttestationData';

/**
 * 
 * @export
 * @interface PasswordVerifyAttestationAllOf
 */
export interface PasswordVerifyAttestationAllOf {
    /**
     * 
     * @type {PasswordVerifyAttestationData}
     * @memberof PasswordVerifyAttestationAllOf
     */
    data?: PasswordVerifyAttestationData;
}

/**
 * Check if a given object implements the PasswordVerifyAttestationAllOf interface.
 */
export function instanceOfPasswordVerifyAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PasswordVerifyAttestationAllOfFromJSON(json: any): PasswordVerifyAttestationAllOf {
    return PasswordVerifyAttestationAllOfFromJSONTyped(json, false);
}

export function PasswordVerifyAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerifyAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PasswordVerifyAttestationDataFromJSON(json['data']),
    };
}

export function PasswordVerifyAttestationAllOfToJSON(value?: PasswordVerifyAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PasswordVerifyAttestationDataToJSON(value.data),
    };
}

